import { axios, Response } from '../index'
import { Folder } from './get-folder-files-and-subfolders'

const getPersonaFolders = (personId: string): Response<Folder[]> => {
  return axios.get(`/v1/personas/${personId}/folders`)
}

export default getPersonaFolders
